export const categoryImages = {
  "Ground Spices": "/images/categories/ground-spices.jpg",
  "Whole Spices": "/images/categories/whole-spices.png",
  Herbs: "/images/categories/herbs.jpg",
  Blends: "/images/categories/blends.jpg",
  Baking: "/images/categories/baking.jpg",
  Salts: "/images/categories/salts.jpg",
  "Rare Ingredients": "/images/categories/rare-ingredients.jpg",
};

const pantryDietary = ["Vegan", "Gluten-free", "No additives"];
const standardStorage =
  "Store sealed in a cool, dry cupboard away from heat and direct sunlight.";

const products = [
  {
    id: 1,
    slug: "smoked-paprika",
    name: "Ember & Oak Smoked Paprika",
    category: "Ground Spices",
    subcategory: "Chile Powders",
    price: 12,
    compareAtPrice: 15,
    rating: 4.9,
    reviewCount: 286,
    sku: "SA-SPP",
    images: ["/images/products/generated/smoked-paprika-v2.png"],
    shortDescription: "Sweet red peppers, slowly smoked over oak for a round campfire warmth.",
    description:
      "A silky paprika with ripe pepper sweetness and a clean ribbon of smoke. Stir it into beans, roast potatoes, tomato sauces, or a quick oil for drizzling over eggs.",
    attributes: {
      origin: "Extremadura, Spain",
      netWeight: "2.4 oz (68 g)",
      form: "Finely ground",
      flavorNotes: ["Sweet pepper", "Oak smoke", "Dried tomato"],
      heatLevel: "Mild",
      ingredients: "Smoked red pepper",
      dietary: pantryDietary,
      storage: standardStorage,
    },
    tags: ["smoky", "spanish", "grilling", "weeknight"],
    variants: [
      { id: "smoked-paprika-jar", name: "Pantry jar", size: "2.4 oz", price: 12, sku: "SA-SPP-24", stock: 58 },
      { id: "smoked-paprika-refill", name: "Refill pouch", size: "5 oz", price: 20, sku: "SA-SPP-50", stock: 34 },
    ],
    stock: 92,
    badges: ["Best Seller", "Small Batch"],
  },
  {
    id: 2,
    slug: "ceylon-cinnamon",
    name: "Sun-Warmed Ceylon Cinnamon",
    category: "Baking",
    subcategory: "Sweet Spices",
    price: 14,
    compareAtPrice: null,
    rating: 4.9,
    reviewCount: 241,
    sku: "SA-CCN",
    images: ["/images/products/generated/ceylon-cinnamon-v2.png"],
    shortDescription: "Delicate true cinnamon with citrus lift and soft honeyed warmth.",
    description:
      "Thin quills of Ceylon cinnamon are milled in small lots to protect their floral aroma. It is gentle enough for fruit, porridge, coffee, and custards yet layered enough for savory braises.",
    attributes: {
      origin: "Matale, Sri Lanka",
      netWeight: "2 oz (57 g)",
      form: "Ground",
      flavorNotes: ["Citrus peel", "Honey", "Soft wood"],
      heatLevel: "None",
      ingredients: "Ceylon cinnamon",
      dietary: pantryDietary,
      storage: standardStorage,
    },
    tags: ["sweet", "floral", "baking", "single-origin", "wellness"],
    variants: [
      { id: "ceylon-cinnamon-jar", name: "Pantry jar", size: "2 oz", price: 14, sku: "SA-CCN-20", stock: 44 },
      { id: "ceylon-cinnamon-refill", name: "Refill pouch", size: "4 oz", price: 23, sku: "SA-CCN-40", stock: 29 },
    ],
    stock: 73,
    badges: ["Best Seller", "Single Origin"],
  },
  {
    id: 3,
    slug: "green-cardamom",
    name: "Nilgiri Green Cardamom",
    category: "Whole Spices",
    subcategory: "Pods & Seeds",
    price: 16,
    compareAtPrice: 19,
    rating: 4.8,
    reviewCount: 194,
    sku: "SA-GCM",
    images: ["/images/products/generated/green-cardamom-v2.png"],
    shortDescription: "Plump green pods alive with eucalyptus, lime zest, and sweet resin.",
    description:
      "These high-grown pods are selected for vivid color and an unusually bright perfume. Crack them for rice and tea, or grind the black seeds into cakes, buns, and spice rubs.",
    attributes: {
      origin: "Nilgiri Hills, India",
      netWeight: "1.8 oz (51 g)",
      form: "Whole pods",
      flavorNotes: ["Eucalyptus", "Lime zest", "Sweet resin"],
      heatLevel: "None",
      ingredients: "Green cardamom pods",
      dietary: pantryDietary,
      storage: standardStorage,
    },
    tags: ["aromatic", "tea", "rice", "single-origin", "wellness"],
    variants: [
      { id: "green-cardamom-jar", name: "Pantry jar", size: "1.8 oz", price: 16, sku: "SA-GCM-18", stock: 37 },
      { id: "green-cardamom-refill", name: "Refill pouch", size: "3.6 oz", price: 28, sku: "SA-GCM-36", stock: 21 },
    ],
    stock: 58,
    badges: ["Best Seller", "Single Origin"],
  },
  {
    id: 4,
    slug: "zaatar",
    name: "Cedar Grove Za’atar",
    category: "Blends",
    subcategory: "Savory Blends",
    price: 13,
    compareAtPrice: null,
    rating: 4.9,
    reviewCount: 318,
    sku: "SA-ZTR",
    images: ["/images/products/generated/zaatar-v2.png"],
    shortDescription: "Wild thyme, tart sumac, toasted sesame, and a whisper of sea salt.",
    description:
      "Our fragrant house za’atar balances herbal lift with sumac tang and nutty sesame. Bloom it in olive oil, scatter it over flatbread, or use it to wake up roast vegetables and yogurt.",
    attributes: {
      origin: "Blended for madezuno",
      netWeight: "2.6 oz (74 g)",
      form: "Coarse blend",
      flavorNotes: ["Wild thyme", "Lemon tang", "Toasted sesame"],
      heatLevel: "None",
      ingredients: "Thyme, sumac, sesame seeds, sea salt",
      dietary: ["Vegan", "Gluten-free"],
      storage: standardStorage,
    },
    tags: ["levantine", "tangy", "herbal", "house-blend"],
    variants: [
      { id: "zaatar-jar", name: "Pantry jar", size: "2.6 oz", price: 13, sku: "SA-ZTR-26", stock: 62 },
      { id: "zaatar-refill", name: "Refill pouch", size: "5.2 oz", price: 22, sku: "SA-ZTR-52", stock: 40 },
    ],
    stock: 102,
    badges: ["Best Seller", "House Blend"],
  },
  {
    id: 5,
    slug: "pink-salt",
    name: "Rose Quartz Pink Salt",
    category: "Salts",
    subcategory: "Mineral Salts",
    price: 10,
    compareAtPrice: null,
    rating: 4.7,
    reviewCount: 169,
    sku: "SA-PKS",
    images: ["/images/products/generated/pink-salt-v2.png"],
    shortDescription: "Clean, mineral-rich crystals for the grinder, table, and finishing bowl.",
    description:
      "Naturally rosy crystals with a direct, balanced salinity and satisfying crunch. Grind over daily cooking or leave the crystals whole for salt-baked fish and vegetables.",
    attributes: {
      origin: "Punjab mineral range, Pakistan",
      netWeight: "5.5 oz (156 g)",
      form: "Medium crystals",
      flavorNotes: ["Clean saline", "Mineral", "Crisp finish"],
      heatLevel: "None",
      ingredients: "Pink mineral salt",
      dietary: pantryDietary,
      storage: "Keep sealed and dry. Salt naturally has an indefinite shelf life.",
    },
    tags: ["mineral", "finishing", "grinder", "everyday"],
    variants: [
      { id: "pink-salt-jar", name: "Pantry jar", size: "5.5 oz", price: 10, sku: "SA-PKS-55", stock: 74 },
      { id: "pink-salt-refill", name: "Refill pouch", size: "12 oz", price: 17, sku: "SA-PKS-120", stock: 48 },
    ],
    stock: 122,
    badges: ["Best Seller"],
  },
  {
    id: 6,
    slug: "saffron",
    name: "Dawn Harvest Saffron",
    category: "Rare Ingredients",
    subcategory: "Threads & Flowers",
    price: 24,
    compareAtPrice: 28,
    rating: 4.9,
    reviewCount: 127,
    sku: "SA-SFR",
    images: ["/images/products/generated/saffron-v2.png"],
    shortDescription: "Deep crimson threads with honeyed hay, rose, and a luminous golden color.",
    description:
      "Handpicked crocus threads chosen for a long crimson style and powerful aroma. Steep a pinch in warm water before adding it to rice, seafood, breads, or custard.",
    attributes: {
      origin: "Khorasan, Iran",
      netWeight: "0.04 oz (1 g)",
      form: "Whole threads",
      flavorNotes: ["Honeyed hay", "Rose", "Warm earth"],
      heatLevel: "None",
      ingredients: "Saffron threads",
      dietary: pantryDietary,
      storage: standardStorage,
    },
    tags: ["floral", "rice", "special-occasion", "single-origin"],
    variants: [
      { id: "saffron-vial", name: "Glass vial", size: "1 g", price: 24, sku: "SA-SFR-10", stock: 28 },
      { id: "saffron-double", name: "Cook’s box", size: "2 g", price: 42, sku: "SA-SFR-20", stock: 15 },
    ],
    stock: 43,
    badges: ["Limited Harvest", "Single Origin"],
  },
  {
    id: 7,
    slug: "aleppo-pepper",
    name: "Orchard-Fruit Aleppo Pepper",
    category: "Ground Spices",
    subcategory: "Chile Flakes",
    price: 11,
    compareAtPrice: null,
    rating: 4.8,
    reviewCount: 153,
    sku: "SA-ALP",
    images: ["/images/products/generated/aleppo-pepper.png"],
    shortDescription: "Soft chile flakes with raisin sweetness, gentle warmth, and a bright finish.",
    description:
      "A plush, oily chile flake that brings more fruit than fire. Sprinkle it over grilled cheese, lentils, eggs, noodles, or anything that needs mellow warmth.",
    attributes: {
      origin: "Gaziantep region, Türkiye",
      netWeight: "2.2 oz (62 g)",
      form: "Crushed flakes",
      flavorNotes: ["Sun-dried tomato", "Raisin", "Mild chile"],
      heatLevel: "Mild",
      ingredients: "Aleppo-style chile, salt, sunflower oil",
      dietary: ["Vegan", "Gluten-free"],
      storage: standardStorage,
    },
    tags: ["fruity", "mild-heat", "levantine", "finishing"],
    variants: [
      { id: "aleppo-pepper-jar", name: "Pantry jar", size: "2.2 oz", price: 11, sku: "SA-ALP-22", stock: 51 },
      { id: "aleppo-pepper-refill", name: "Refill pouch", size: "4.5 oz", price: 19, sku: "SA-ALP-45", stock: 30 },
    ],
    stock: 81,
    badges: ["Staff Pick"],
  },
  {
    id: 8,
    slug: "tellicherry-black-pepper",
    name: "Rainforest Tellicherry Pepper",
    category: "Whole Spices",
    subcategory: "Peppercorns",
    price: 13,
    compareAtPrice: null,
    rating: 4.8,
    reviewCount: 205,
    sku: "SA-TBP",
    images: ["/images/products/generated/tellicherry-black-pepper.png"],
    shortDescription: "Extra-bold peppercorns with pine, citrus, and a lingering clean bite.",
    description:
      "Large, late-harvest pepper berries deliver layered aroma rather than one-note heat. Crack them fresh over steak, greens, strawberries, or creamy pasta.",
    attributes: {
      origin: "Kerala, India",
      netWeight: "2.8 oz (79 g)",
      form: "Whole peppercorns",
      flavorNotes: ["Pine", "Citrus", "Warm spice"],
      heatLevel: "Medium",
      ingredients: "Black peppercorns",
      dietary: pantryDietary,
      storage: standardStorage,
    },
    tags: ["peppery", "grinder", "single-origin", "everyday"],
    variants: [
      { id: "tellicherry-black-pepper-jar", name: "Pantry jar", size: "2.8 oz", price: 13, sku: "SA-TBP-28", stock: 69 },
      { id: "tellicherry-black-pepper-refill", name: "Refill pouch", size: "6 oz", price: 22, sku: "SA-TBP-60", stock: 43 },
    ],
    stock: 112,
    badges: ["Single Origin"],
  },
  {
    id: 9,
    slug: "golden-turmeric",
    name: "Golden Hour Turmeric",
    category: "Ground Spices",
    subcategory: "Roots & Rhizomes",
    price: 9,
    compareAtPrice: null,
    rating: 4.7,
    reviewCount: 181,
    sku: "SA-TUR",
    images: ["/images/products/generated/golden-turmeric.png"],
    shortDescription: "High-color turmeric with apricot earthiness and a pleasantly dry finish.",
    description:
      "Ground from mature rhizomes for saturated color and a balanced flavor. Add it to lentils, rice, pickles, broth, or warm milk with black pepper.",
    attributes: {
      origin: "Erode, India",
      netWeight: "2.5 oz (71 g)",
      form: "Finely ground",
      flavorNotes: ["Apricot", "Earth", "Ginger"],
      heatLevel: "None",
      ingredients: "Turmeric root",
      dietary: pantryDietary,
      storage: standardStorage,
    },
    tags: ["earthy", "golden", "curries", "single-origin", "wellness"],
    variants: [
      { id: "golden-turmeric-jar", name: "Pantry jar", size: "2.5 oz", price: 9, sku: "SA-TUR-25", stock: 63 },
      { id: "golden-turmeric-refill", name: "Refill pouch", size: "5 oz", price: 15, sku: "SA-TUR-50", stock: 42 },
    ],
    stock: 105,
    badges: ["Single Origin"],
  },
  {
    id: 10,
    slug: "wild-cumin-seed",
    name: "Silk Road Cumin Seed",
    category: "Whole Spices",
    subcategory: "Seeds",
    price: 9,
    compareAtPrice: null,
    rating: 4.7,
    reviewCount: 146,
    sku: "SA-CUM",
    images: ["/images/products/generated/wild-cumin-seed.png"],
    shortDescription: "Long, aromatic seeds with toasted earth, lemon peel, and savory depth.",
    description:
      "Warm these cumin seeds in a dry pan until fragrant, then crush or leave whole. Their citrus edge keeps beans, grilled meats, curries, and carrots tasting lively.",
    attributes: {
      origin: "Anatolia, Türkiye",
      netWeight: "2.3 oz (65 g)",
      form: "Whole seeds",
      flavorNotes: ["Toasted earth", "Lemon peel", "Walnut"],
      heatLevel: "None",
      ingredients: "Cumin seed",
      dietary: pantryDietary,
      storage: standardStorage,
    },
    tags: ["earthy", "toasting", "beans", "whole-spice"],
    variants: [
      { id: "wild-cumin-seed-jar", name: "Pantry jar", size: "2.3 oz", price: 9, sku: "SA-CUM-23", stock: 57 },
      { id: "wild-cumin-seed-refill", name: "Refill pouch", size: "5 oz", price: 15, sku: "SA-CUM-50", stock: 33 },
    ],
    stock: 90,
    badges: [],
  },
  {
    id: 11,
    slug: "coriander-seed",
    name: "Citrus-Leaf Coriander Seed",
    category: "Whole Spices",
    subcategory: "Seeds",
    price: 8,
    compareAtPrice: null,
    rating: 4.6,
    reviewCount: 119,
    sku: "SA-COR",
    images: ["/images/products/generated/coriander-seed.png"],
    shortDescription: "Golden seeds with orange peel, sage, and a softly nutty center.",
    description:
      "Coriander is a quiet transformer: toast and crush it for marinades, pickles, sausages, roasted squash, or a bright counterpoint to cumin.",
    attributes: {
      origin: "Madhya Pradesh, India",
      netWeight: "2.1 oz (60 g)",
      form: "Whole seeds",
      flavorNotes: ["Orange peel", "Sage", "Hazelnut"],
      heatLevel: "None",
      ingredients: "Coriander seed",
      dietary: pantryDietary,
      storage: standardStorage,
    },
    tags: ["citrusy", "pickling", "toasting", "whole-spice"],
    variants: [
      { id: "coriander-seed-jar", name: "Pantry jar", size: "2.1 oz", price: 8, sku: "SA-COR-21", stock: 60 },
      { id: "coriander-seed-refill", name: "Refill pouch", size: "5 oz", price: 14, sku: "SA-COR-50", stock: 35 },
    ],
    stock: 95,
    badges: [],
  },
  {
    id: 12,
    slug: "fennel-pollen",
    name: "Tuscan Fennel Pollen",
    category: "Rare Ingredients",
    subcategory: "Pollen & Flowers",
    price: 21,
    compareAtPrice: null,
    rating: 4.9,
    reviewCount: 92,
    sku: "SA-FPL",
    images: ["/images/products/generated/fennel-pollen.png"],
    shortDescription: "A tiny finishing pinch bursting with anise, citrus, and meadow flowers.",
    description:
      "The concentrated golden pollen of wild fennel adds instant fragrance to roast pork, fish, tomatoes, and buttered vegetables. A little goes remarkably far.",
    attributes: {
      origin: "Tuscany, Italy",
      netWeight: "0.5 oz (14 g)",
      form: "Flower pollen",
      flavorNotes: ["Sweet anise", "Lemon", "Meadow flowers"],
      heatLevel: "None",
      ingredients: "Wild fennel pollen",
      dietary: pantryDietary,
      storage: standardStorage,
    },
    tags: ["floral", "finishing", "rare", "single-origin"],
    variants: [
      { id: "fennel-pollen-tin", name: "Finishing tin", size: "0.5 oz", price: 21, sku: "SA-FPL-05", stock: 22 },
      { id: "fennel-pollen-chef", name: "Chef pouch", size: "1 oz", price: 37, sku: "SA-FPL-10", stock: 11 },
    ],
    stock: 33,
    badges: ["Limited Harvest"],
  },
  {
    id: 13,
    slug: "tart-sumac",
    name: "Ruby Sumac",
    category: "Ground Spices",
    subcategory: "Tangy Spices",
    price: 10,
    compareAtPrice: 12,
    rating: 4.8,
    reviewCount: 174,
    sku: "SA-SUM",
    images: ["/images/products/generated/tart-sumac.png"],
    shortDescription: "Velvety crimson flakes with a clean lemon tang and berry-like finish.",
    description:
      "Sumac brings acidity without liquid, making it ideal for salads, grilled onions, fish, dips, and roast chicken. Sprinkle it on just before serving for its brightest flavor.",
    attributes: {
      origin: "Aegean coast, Türkiye",
      netWeight: "2.4 oz (68 g)",
      form: "Coarsely ground",
      flavorNotes: ["Lemon", "Red berry", "Tea"],
      heatLevel: "None",
      ingredients: "Sumac berry, sea salt",
      dietary: ["Vegan", "Gluten-free"],
      storage: standardStorage,
    },
    tags: ["tangy", "levantine", "finishing", "salads"],
    variants: [
      { id: "tart-sumac-jar", name: "Pantry jar", size: "2.4 oz", price: 10, sku: "SA-SUM-24", stock: 49 },
      { id: "tart-sumac-refill", name: "Refill pouch", size: "5 oz", price: 17, sku: "SA-SUM-50", stock: 31 },
    ],
    stock: 80,
    badges: ["Staff Pick"],
  },
  {
    id: 14,
    slug: "urfa-biber",
    name: "Midnight Urfa Biber",
    category: "Ground Spices",
    subcategory: "Chile Flakes",
    price: 12,
    compareAtPrice: null,
    rating: 4.8,
    reviewCount: 137,
    sku: "SA-URF",
    images: ["/images/products/generated/urfa-biber.png"],
    shortDescription: "Dark, supple chile flakes tasting of cocoa, raisin, tobacco, and slow heat.",
    description:
      "Sun-dried by day and wrapped at night, Urfa develops its signature inky color and damp texture. Fold it into lamb, chocolate, eggplant, or browned butter.",
    attributes: {
      origin: "Şanlıurfa, Türkiye",
      netWeight: "2 oz (57 g)",
      form: "Crushed flakes",
      flavorNotes: ["Cocoa", "Raisin", "Tobacco"],
      heatLevel: "Medium",
      ingredients: "Urfa chile, salt, sunflower oil",
      dietary: ["Vegan", "Gluten-free"],
      storage: standardStorage,
    },
    tags: ["chile", "slow-heat", "savory", "single-origin"],
    variants: [
      { id: "urfa-biber-jar", name: "Pantry jar", size: "2 oz", price: 12, sku: "SA-URF-20", stock: 43 },
      { id: "urfa-biber-refill", name: "Refill pouch", size: "4 oz", price: 20, sku: "SA-URF-40", stock: 24 },
    ],
    stock: 67,
    badges: ["Single Origin"],
  },
  {
    id: 15,
    slug: "ras-el-hanout",
    name: "Marrakech No. 7 Ras el Hanout",
    category: "Blends",
    subcategory: "Savory Blends",
    price: 15,
    compareAtPrice: null,
    rating: 4.8,
    reviewCount: 162,
    sku: "SA-REH",
    images: ["/images/products/generated/ras-el-hanout.png"],
    shortDescription: "A generous North African blend of rose, warming spice, pepper, and roots.",
    description:
      "Our seven-layered blend moves from floral to warm to savory without overpowering the dish. Rub it onto lamb, toss with carrots, or stir into couscous and tagines.",
    attributes: {
      origin: "Blended for madezuno",
      netWeight: "2.2 oz (62 g)",
      form: "Ground blend",
      flavorNotes: ["Rose", "Warm spice", "Pepper"],
      heatLevel: "Mild",
      ingredients: "Coriander, cumin, ginger, cinnamon, turmeric, black pepper, rose petal",
      dietary: pantryDietary,
      storage: standardStorage,
    },
    tags: ["moroccan", "floral", "warming", "house-blend"],
    variants: [
      { id: "ras-el-hanout-jar", name: "Pantry jar", size: "2.2 oz", price: 15, sku: "SA-REH-22", stock: 38 },
      { id: "ras-el-hanout-refill", name: "Refill pouch", size: "4.5 oz", price: 25, sku: "SA-REH-45", stock: 22 },
    ],
    stock: 60,
    badges: ["House Blend"],
  },
  {
    id: 16,
    slug: "garam-masala",
    name: "Hearth Garam Masala",
    category: "Blends",
    subcategory: "Savory Blends",
    price: 12,
    compareAtPrice: null,
    rating: 4.7,
    reviewCount: 188,
    sku: "SA-GRM",
    images: ["/images/products/generated/garam-masala.png"],
    shortDescription: "Freshly toasted cardamom, cinnamon, cumin, clove, and pepper in balance.",
    description:
      "Built for aroma rather than raw heat, this blend is toasted and milled in small batches. Add it near the end of cooking to lentils, curries, roast squash, or buttered rice.",
    attributes: {
      origin: "Blended for madezuno",
      netWeight: "2.3 oz (65 g)",
      form: "Ground blend",
      flavorNotes: ["Cardamom", "Toasted cumin", "Clove"],
      heatLevel: "Mild",
      ingredients: "Coriander, cumin, cardamom, cinnamon, black pepper, clove, bay leaf",
      dietary: pantryDietary,
      storage: standardStorage,
    },
    tags: ["indian", "warming", "curries", "house-blend"],
    variants: [
      { id: "garam-masala-jar", name: "Pantry jar", size: "2.3 oz", price: 12, sku: "SA-GRM-23", stock: 55 },
      { id: "garam-masala-refill", name: "Refill pouch", size: "5 oz", price: 20, sku: "SA-GRM-50", stock: 36 },
    ],
    stock: 91,
    badges: ["House Blend"],
  },
  {
    id: 17,
    slug: "ember-berbere",
    name: "Red Clay Berbere",
    category: "Blends",
    subcategory: "Chile Blends",
    price: 13,
    compareAtPrice: 16,
    rating: 4.8,
    reviewCount: 143,
    sku: "SA-BER",
    images: ["/images/products/generated/ember-berbere.png"],
    shortDescription: "A brick-red Ethiopian-inspired blend with chile, fenugreek, and cardamom.",
    description:
      "Layered, aromatic heat makes this blend as useful in a weeknight tray bake as in a long-simmered stew. Mix it with oil for cauliflower, chicken, chickpeas, or lentils.",
    attributes: {
      origin: "Blended for madezuno",
      netWeight: "2.4 oz (68 g)",
      form: "Ground blend",
      flavorNotes: ["Red chile", "Fenugreek", "Warm citrus"],
      heatLevel: "Hot",
      ingredients: "Chile, paprika, coriander, fenugreek, ginger, cardamom, allspice, clove",
      dietary: pantryDietary,
      storage: standardStorage,
    },
    tags: ["ethiopian-inspired", "hot", "stews", "house-blend"],
    variants: [
      { id: "ember-berbere-jar", name: "Pantry jar", size: "2.4 oz", price: 13, sku: "SA-BER-24", stock: 41 },
      { id: "ember-berbere-refill", name: "Refill pouch", size: "5 oz", price: 22, sku: "SA-BER-50", stock: 25 },
    ],
    stock: 66,
    badges: ["House Blend"],
  },
  {
    id: 18,
    slug: "herbes-de-provence",
    name: "Lavender Field Herbes de Provence",
    category: "Blends",
    subcategory: "Herb Blends",
    price: 11,
    compareAtPrice: null,
    rating: 4.6,
    reviewCount: 104,
    sku: "SA-HDP",
    images: ["/images/products/generated/herbes-de-provence.png"],
    shortDescription: "Thyme, savory, rosemary, fennel, and just enough culinary lavender.",
    description:
      "A restrained floral blend inspired by sunlit southern French hillsides. Crush it between your palms over roast chicken, white beans, tomatoes, or goat cheese.",
    attributes: {
      origin: "Blended for madezuno",
      netWeight: "1.4 oz (40 g)",
      form: "Dried herb blend",
      flavorNotes: ["Thyme", "Pine", "Soft lavender"],
      heatLevel: "None",
      ingredients: "Thyme, savory, rosemary, fennel seed, culinary lavender",
      dietary: pantryDietary,
      storage: standardStorage,
    },
    tags: ["french", "herbal", "roasting", "house-blend"],
    variants: [
      { id: "herbes-de-provence-jar", name: "Pantry jar", size: "1.4 oz", price: 11, sku: "SA-HDP-14", stock: 48 },
      { id: "herbes-de-provence-refill", name: "Refill pouch", size: "3 oz", price: 18, sku: "SA-HDP-30", stock: 27 },
    ],
    stock: 75,
    badges: [],
  },
  {
    id: 19,
    slug: "greek-oregano",
    name: "Mountain Greek Oregano",
    category: "Herbs",
    subcategory: "Leafy Herbs",
    price: 9,
    compareAtPrice: null,
    rating: 4.8,
    reviewCount: 132,
    sku: "SA-ORG",
    images: ["/images/products/generated/greek-oregano.png"],
    shortDescription: "Hand-rubbed leaves with peppery intensity and a clean green finish.",
    description:
      "This high-grown oregano is richly aromatic, so a pinch is often enough. Rub it between your fingers over tomatoes, feta, lemon potatoes, grilled fish, and beans.",
    attributes: {
      origin: "Taygetus Mountains, Greece",
      netWeight: "0.8 oz (23 g)",
      form: "Hand-rubbed leaves",
      flavorNotes: ["Pepper", "Wild mint", "Green olive"],
      heatLevel: "None",
      ingredients: "Greek oregano",
      dietary: pantryDietary,
      storage: standardStorage,
    },
    tags: ["greek", "herbal", "tomato", "single-origin"],
    variants: [
      { id: "greek-oregano-jar", name: "Pantry jar", size: "0.8 oz", price: 9, sku: "SA-ORG-08", stock: 52 },
      { id: "greek-oregano-refill", name: "Refill pouch", size: "1.8 oz", price: 15, sku: "SA-ORG-18", stock: 32 },
    ],
    stock: 84,
    badges: ["Single Origin"],
  },
  {
    id: 20,
    slug: "rosemary-needles",
    name: "Coastal Rosemary Needles",
    category: "Herbs",
    subcategory: "Leafy Herbs",
    price: 8,
    compareAtPrice: null,
    rating: 4.6,
    reviewCount: 88,
    sku: "SA-RSM",
    images: ["/images/products/generated/rosemary-needles.png"],
    shortDescription: "Fragrant whole needles carrying pine, lemon, and a hint of sea breeze.",
    description:
      "Slow-dried rosemary keeps its resinous aroma and bright green character. Crush before using in focaccia, roast potatoes, lamb, citrus cakes, or infused oil.",
    attributes: {
      origin: "Dalmatian coast, Croatia",
      netWeight: "1 oz (28 g)",
      form: "Whole dried needles",
      flavorNotes: ["Pine", "Lemon", "Camphor"],
      heatLevel: "None",
      ingredients: "Rosemary",
      dietary: pantryDietary,
      storage: standardStorage,
    },
    tags: ["mediterranean", "herbal", "potatoes", "bread"],
    variants: [
      { id: "rosemary-needles-jar", name: "Pantry jar", size: "1 oz", price: 8, sku: "SA-RSM-10", stock: 46 },
      { id: "rosemary-needles-refill", name: "Refill pouch", size: "2.2 oz", price: 13, sku: "SA-RSM-22", stock: 30 },
    ],
    stock: 76,
    badges: [],
  },
  {
    id: 21,
    slug: "garden-thyme",
    name: "Garden Thyme",
    category: "Herbs",
    subcategory: "Leafy Herbs",
    price: 8,
    compareAtPrice: null,
    rating: 4.6,
    reviewCount: 97,
    sku: "SA-THY",
    images: ["/images/products/generated/garden-thyme.png"],
    shortDescription: "Tiny leaves with savory depth, lemon lift, and a gentle woodsy finish.",
    description:
      "A pantry foundation selected for concentrated aroma. Add it early to soups and braises, or crush it over mushrooms, chicken, carrots, and creamy beans.",
    attributes: {
      origin: "Thessaly, Greece",
      netWeight: "0.9 oz (26 g)",
      form: "Dried leaves",
      flavorNotes: ["Savory", "Lemon", "Dry wood"],
      heatLevel: "None",
      ingredients: "Thyme",
      dietary: pantryDietary,
      storage: standardStorage,
    },
    tags: ["herbal", "soups", "roasting", "everyday"],
    variants: [
      { id: "garden-thyme-jar", name: "Pantry jar", size: "0.9 oz", price: 8, sku: "SA-THY-09", stock: 55 },
      { id: "garden-thyme-refill", name: "Refill pouch", size: "2 oz", price: 13, sku: "SA-THY-20", stock: 34 },
    ],
    stock: 89,
    badges: [],
  },
  {
    id: 22,
    slug: "madagascar-vanilla-beans",
    name: "Madagascar Vanilla Beans",
    category: "Baking",
    subcategory: "Pods & Extracts",
    price: 19,
    compareAtPrice: 22,
    rating: 4.9,
    reviewCount: 116,
    sku: "SA-VAN",
    images: ["/images/products/generated/madagascar-vanilla-beans.png"],
    shortDescription: "Supple Grade A beans with dark cocoa, cream, and ripe cherry aroma.",
    description:
      "Glossy, pliable beans packed for pastry, custard, ice cream, and homemade extract. Split the pod for its seeds, then tuck the spent pod into sugar.",
    attributes: {
      origin: "Sava region, Madagascar",
      netWeight: "3 beans",
      form: "Whole cured pods",
      flavorNotes: ["Cream", "Dark cocoa", "Ripe cherry"],
      heatLevel: "None",
      ingredients: "Vanilla beans",
      dietary: pantryDietary,
      storage: "Keep sealed at room temperature; do not refrigerate.",
    },
    tags: ["vanilla", "baking", "dessert", "single-origin"],
    variants: [
      { id: "madagascar-vanilla-beans-three", name: "Baker’s tube", size: "3 beans", price: 19, sku: "SA-VAN-03", stock: 31 },
      { id: "madagascar-vanilla-beans-six", name: "Pastry box", size: "6 beans", price: 34, sku: "SA-VAN-06", stock: 18 },
    ],
    stock: 49,
    badges: ["Single Origin"],
  },
  {
    id: 23,
    slug: "dutch-cocoa",
    name: "Deep Roast Dutch Cocoa",
    category: "Baking",
    subcategory: "Cocoa & Carob",
    price: 13,
    compareAtPrice: null,
    rating: 4.8,
    reviewCount: 109,
    sku: "SA-COC",
    images: ["/images/products/generated/dutch-cocoa.png"],
    shortDescription: "Alkalized cocoa with mahogany color and mellow bittersweet depth.",
    description:
      "Smooth, deeply colored cocoa designed for brownies, cakes, cookies, and drinking chocolate. Its rounded acidity also works beautifully in chile and barbecue rubs.",
    attributes: {
      origin: "Processed in the Netherlands",
      netWeight: "5 oz (142 g)",
      form: "Fine powder",
      flavorNotes: ["Dark chocolate", "Malt", "Roasted nut"],
      heatLevel: "None",
      ingredients: "Alkalized cocoa powder",
      dietary: pantryDietary,
      storage: standardStorage,
    },
    tags: ["cocoa", "baking", "chocolate", "savory"],
    variants: [
      { id: "dutch-cocoa-tin", name: "Baker’s tin", size: "5 oz", price: 13, sku: "SA-COC-50", stock: 47 },
      { id: "dutch-cocoa-pouch", name: "Refill pouch", size: "10 oz", price: 22, sku: "SA-COC-100", stock: 26 },
    ],
    stock: 73,
    badges: ["Staff Pick"],
  },
  {
    id: 24,
    slug: "ginger-root-powder",
    name: "Bright Ginger Root",
    category: "Ground Spices",
    subcategory: "Roots & Rhizomes",
    price: 9,
    compareAtPrice: null,
    rating: 4.7,
    reviewCount: 124,
    sku: "SA-GIN",
    images: ["/images/products/generated/ginger-root-powder.png"],
    shortDescription: "Fine golden ginger with lemony heat and a lingering candied sweetness.",
    description:
      "A bright, clean ginger powder made from mature roots. Whisk it into cookies, granola, marinades, squash soup, or a fast cup of warming tea.",
    attributes: {
      origin: "Kerala, India",
      netWeight: "2.2 oz (62 g)",
      form: "Finely ground",
      flavorNotes: ["Lemon", "Candied ginger", "Peppery heat"],
      heatLevel: "Medium",
      ingredients: "Ginger root",
      dietary: pantryDietary,
      storage: standardStorage,
    },
    tags: ["ginger", "baking", "warming", "tea", "wellness"],
    variants: [
      { id: "ginger-root-powder-jar", name: "Pantry jar", size: "2.2 oz", price: 9, sku: "SA-GIN-22", stock: 54 },
      { id: "ginger-root-powder-refill", name: "Refill pouch", size: "5 oz", price: 15, sku: "SA-GIN-50", stock: 37 },
    ],
    stock: 91,
    badges: [],
  },
  {
    id: 25,
    slug: "whole-nutmeg",
    name: "Island Whole Nutmeg",
    category: "Whole Spices",
    subcategory: "Baking Spices",
    price: 11,
    compareAtPrice: null,
    rating: 4.8,
    reviewCount: 101,
    sku: "SA-NUT",
    images: ["/images/products/generated/whole-nutmeg.png"],
    shortDescription: "Dense whole seeds with buttery warmth, orange oil, and gentle pepper.",
    description:
      "Freshly grated nutmeg has a brightness no pre-ground jar can match. Shave it over béchamel, greens, mashed potatoes, custard, or winter drinks.",
    attributes: {
      origin: "Grenada",
      netWeight: "1.5 oz (43 g)",
      form: "Whole seeds",
      flavorNotes: ["Butter", "Orange oil", "Warm pepper"],
      heatLevel: "None",
      ingredients: "Whole nutmeg",
      dietary: pantryDietary,
      storage: standardStorage,
    },
    tags: ["nutmeg", "grating", "baking", "single-origin"],
    variants: [
      { id: "whole-nutmeg-jar", name: "Pantry jar", size: "5–6 seeds", price: 11, sku: "SA-NUT-06", stock: 39 },
      { id: "whole-nutmeg-refill", name: "Refill pouch", size: "12 seeds", price: 19, sku: "SA-NUT-12", stock: 24 },
    ],
    stock: 63,
    badges: ["Single Origin"],
  },
  {
    id: 26,
    slug: "flaky-sea-salt",
    name: "Snowflake Sea Salt",
    category: "Salts",
    subcategory: "Finishing Salts",
    price: 12,
    compareAtPrice: null,
    rating: 4.8,
    reviewCount: 221,
    sku: "SA-FSS",
    images: ["/images/products/generated/flaky-sea-salt.png"],
    shortDescription: "Feathery crystals that dissolve cleanly and add a delicate final crunch.",
    description:
      "Hand-harvested pyramids with a brittle texture and pure salinity. Pinch them over tomatoes, focaccia, roast vegetables, chocolate cookies, or caramel.",
    attributes: {
      origin: "Maine coast, United States",
      netWeight: "3.5 oz (99 g)",
      form: "Flaky crystals",
      flavorNotes: ["Clean saline", "Ocean mineral", "Crisp finish"],
      heatLevel: "None",
      ingredients: "Sea salt",
      dietary: pantryDietary,
      storage: "Keep sealed and dry. Salt naturally has an indefinite shelf life.",
    },
    tags: ["finishing", "flaky", "dessert", "local"],
    variants: [
      { id: "flaky-sea-salt-box", name: "Finishing box", size: "3.5 oz", price: 12, sku: "SA-FSS-35", stock: 67 },
      { id: "flaky-sea-salt-refill", name: "Refill pouch", size: "7 oz", price: 20, sku: "SA-FSS-70", stock: 38 },
    ],
    stock: 105,
    badges: ["Staff Pick"],
  },
  {
    id: 27,
    slug: "alder-smoked-sea-salt",
    name: "Alderwood Smoked Salt",
    category: "Salts",
    subcategory: "Smoked Salts",
    price: 13,
    compareAtPrice: null,
    rating: 4.7,
    reviewCount: 93,
    sku: "SA-ASS",
    images: ["/images/products/generated/alder-smoked-sea-salt.png"],
    shortDescription: "Sea salt cold-smoked over alder for a clean, savory woodland aroma.",
    description:
      "A measured smoke that seasons rather than overwhelms. Use it on mushrooms, corn, grilled fish, baked potatoes, or as a final touch for a meatless stew.",
    attributes: {
      origin: "Pacific Northwest, United States",
      netWeight: "3.8 oz (108 g)",
      form: "Fine crystals",
      flavorNotes: ["Alder smoke", "Clean saline", "Savory wood"],
      heatLevel: "None",
      ingredients: "Sea salt, natural alderwood smoke",
      dietary: pantryDietary,
      storage: "Keep sealed and dry. Salt naturally has an indefinite shelf life.",
    },
    tags: ["smoky", "finishing", "grilling", "savory"],
    variants: [
      { id: "alder-smoked-sea-salt-jar", name: "Pantry jar", size: "3.8 oz", price: 13, sku: "SA-ASS-38", stock: 42 },
      { id: "alder-smoked-sea-salt-refill", name: "Refill pouch", size: "8 oz", price: 22, sku: "SA-ASS-80", stock: 23 },
    ],
    stock: 65,
    badges: ["Small Batch"],
  },
  {
    id: 28,
    slug: "blue-fenugreek",
    name: "Alpine Blue Fenugreek",
    category: "Rare Ingredients",
    subcategory: "Leaves & Petals",
    price: 14,
    compareAtPrice: null,
    rating: 4.7,
    reviewCount: 72,
    sku: "SA-BFG",
    images: ["/images/products/generated/blue-fenugreek.png"],
    shortDescription: "An uncommon dried herb with toasted hay, walnut, and maple-like savor.",
    description:
      "Blue fenugreek is gentler and more herbal than the familiar seed. Crush it into bread dough, bean dishes, soft cheese, potatoes, or a savory butter.",
    attributes: {
      origin: "Racha highlands, Georgia",
      netWeight: "1.1 oz (31 g)",
      form: "Dried leaves and flowers",
      flavorNotes: ["Toasted hay", "Walnut", "Maple"],
      heatLevel: "None",
      ingredients: "Blue fenugreek",
      dietary: pantryDietary,
      storage: standardStorage,
    },
    tags: ["rare", "georgian", "bread", "savory"],
    variants: [
      { id: "blue-fenugreek-jar", name: "Pantry jar", size: "1.1 oz", price: 14, sku: "SA-BFG-11", stock: 29 },
      { id: "blue-fenugreek-refill", name: "Refill pouch", size: "2.2 oz", price: 24, sku: "SA-BFG-22", stock: 14 },
    ],
    stock: 43,
    badges: ["Rare Find"],
  },
];

// Keep the established catalogue and product names while presenting every
// purchasable option within the requested storefront price band.
products.forEach((product, index) => {
  const basePrice = 45 + index * 4;
  product.price = basePrice;
  if (product.compareAtPrice) product.compareAtPrice = Math.min(180, basePrice + 12);
  product.variants = product.variants.map((variant, variantIndex) => ({
    ...variant,
    price: Math.min(180, basePrice + variantIndex * 18),
  }));
});

export const productCategories = Object.entries(categoryImages).map(
  ([name, image]) => ({
    name,
    slug: name.toLowerCase().replace(/&/g, "and").replace(/\s+/g, "-"),
    image,
    count: products.filter((product) => product.category === name).length,
  })
);

export const getProductBySlug = (slug) =>
  products.find((product) => product.slug === slug);

export const getProductById = (id) =>
  products.find((product) => String(product.id) === String(id));

export { products };
export default products;
